var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1361px",
    height: "609px",
    viewBox: "0 0 1361 609",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ant-Design-Pro-3.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8D26\\u6237\\u5BC6\\u7801\\u767B\\u5F55-\\u6821\\u9A8C",
    transform: "translate(-79.000000, -82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(77.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    opacity: 0.8,
    transform: "translate(74.901416, 569.699158) rotate(-7.000000) translate(-74.901416, -569.699158) translate(4.901416, 525.199158)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-11",
    fill: "#CFDAE6",
    opacity: 0.25,
    cx: 63.5748792,
    cy: 32.468367,
    rx: 21.7830479,
    ry: 21.766008
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    fill: "#CFDAE6",
    opacity: 0.599999964,
    cx: 5.98746479,
    cy: 13.8668601,
    rx: 5.2173913,
    ry: 5.21330997
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1354514,88.3520215 C43.8984227,88.3520215 48.570234,83.6838647 48.570234,77.9254015 C48.570234,72.1669383 43.8984227,67.4987816 38.1354514,67.4987816 C32.3724801,67.4987816 27.7006688,72.1669383 27.7006688,77.9254015 C27.7006688,83.6838647 32.3724801,88.3520215 38.1354514,88.3520215 Z",
    id: "Oval-3-Copy",
    fill: "#CFDAE6",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2775582,33.1704963 L119.185836,16.5654915",
    id: "Path-12",
    stroke: "#CFDAE6",
    strokeWidth: 1.73913043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1431708,26.5002681 L7.71190162,14.5640702",
    id: "Path-16",
    stroke: "#E0B4B7",
    strokeWidth: 0.702678964,
    opacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.405357899873153,2.108036953469981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9262187,33.521561 L43.6721326,69.3250951",
    id: "Path-15",
    stroke: "#BACAD9",
    strokeWidth: 0.702678964,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.405357899873153,2.108036953469981"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(126.850922, 13.543654) rotate(30.000000) translate(-126.850922, -13.543654) translate(117.285705, 4.381889)",
    fill: "#CFDAE6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    opacity: 0.45,
    cx: 9.13482653,
    cy: 9.12768076,
    rx: 9.13482653,
    ry: 9.12768076
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2696531,18.2553615 C18.2696531,13.2142826 14.1798519,9.12768076 9.13482653,9.12768076 C4.08980114,9.12768076 0,13.2142826 0,18.2553615 L18.2696531,18.2553615 Z",
    id: "Oval-4",
    transform: "translate(9.134827, 13.691521) scale(-1, -1) translate(-9.134827, -13.691521) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(216.294700, 123.725600) rotate(-5.000000) translate(-216.294700, -123.725600) translate(106.294700, 35.225600)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    fill: "#CFDAE6",
    opacity: 0.25,
    cx: 29.1176471,
    cy: 29.1402439,
    rx: 29.1176471,
    ry: 29.1402439
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    fill: "#CFDAE6",
    opacity: 0.3,
    cx: 29.1176471,
    cy: 29.1402439,
    rx: 21.5686275,
    ry: 21.5853659
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2-Copy",
    stroke: "#CFDAE6",
    opacity: 0.4,
    cx: 179.019608,
    cy: 138.146341,
    rx: 23.7254902,
    ry: 23.7439024
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    fill: "#BACAD9",
    opacity: 0.5,
    cx: 29.1176471,
    cy: 29.1402439,
    rx: 10.7843137,
    ry: 10.7926829
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1176471,39.9329268 L29.1176471,18.347561 C23.1616351,18.347561 18.3333333,23.1796097 18.3333333,29.1402439 C18.3333333,35.1008781 23.1616351,39.9329268 29.1176471,39.9329268 Z",
    id: "Oval-2",
    fill: "#BACAD9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    opacity: 0.45,
    transform: "translate(172.000000, 131.000000)",
    fill: "#E6A1A6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2-Copy-2",
    cx: 7.01960784,
    cy: 7.14634146,
    rx: 6.47058824,
    ry: 6.47560976
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.549019608,13.6219512 C4.12262681,13.6219512 7.01960784,10.722722 7.01960784,7.14634146 C7.01960784,3.56996095 4.12262681,0.670731707 0.549019608,0.670731707 L0.549019608,13.6219512 Z",
    id: "Oval-2-Copy-2",
    transform: "translate(3.784314, 7.146341) scale(-1, 1) translate(-3.784314, -7.146341) "
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-10",
    fill: "#CFDAE6",
    cx: 218.382353,
    cy: 138.685976,
    rx: 1.61764706,
    ry: 1.61890244
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-10-Copy-2",
    fill: "#E0B4B7",
    opacity: 0.35,
    cx: 179.558824,
    cy: 175.381098,
    rx: 1.61764706,
    ry: 1.61890244
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-10-Copy",
    fill: "#E0B4B7",
    opacity: 0.35,
    cx: 180.098039,
    cy: 102.530488,
    rx: 2.15686275,
    ry: 2.15853659
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9985381,29.9671598 L171.151018,132.876024",
    id: "Path-11",
    stroke: "#CFDAE6",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    opacity: 0.799999952,
    transform: "translate(1054.100635, 36.659317) rotate(-11.000000) translate(-1054.100635, -36.659317) translate(1026.600635, 4.659317)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-7",
    stroke: "#CFDAE6",
    strokeWidth: 0.941176471,
    cx: 43.8135593,
    cy: 32,
    rx: 11.1864407,
    ry: 11.2941176
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(34.596774, 23.111111)",
    fill: "#BACAD9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-7",
    opacity: 0.45,
    cx: 9.18534718,
    cy: 8.88888889,
    rx: 8.47457627,
    ry: 8.55614973
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18534718,17.4450386 C13.8657264,17.4450386 17.6599235,13.6143199 17.6599235,8.88888889 C17.6599235,4.16345787 13.8657264,0.332739156 9.18534718,0.332739156 L9.18534718,17.4450386 Z",
    id: "Oval-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.6597385,24.809694 L5.71666084,4.76878945",
    id: "Path-2",
    stroke: "#CFDAE6",
    strokeWidth: 0.941176471
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#CFDAE6",
    strokeWidth: 0.941176471,
    cx: 3.26271186,
    cy: 3.29411765,
    rx: 3.26271186,
    ry: 3.29411765
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#F7E1AD",
    cx: 2.79661017,
    cy: 61.1764706,
    rx: 2.79661017,
    ry: 2.82352941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6312443,39.2922712 L5.06366663,59.785082",
    id: "Path-10",
    stroke: "#CFDAE6",
    strokeWidth: 0.941176471
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    opacity: 0.33,
    transform: "translate(1282.537219, 446.502867) rotate(-10.000000) translate(-1282.537219, -446.502867) translate(1142.537219, 327.502867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(141.333539, 104.502742) rotate(275.000000) translate(-141.333539, -104.502742) translate(129.333539, 92.502742)",
    fill: "#BACAD9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    opacity: 0.45,
    cx: 11.6666667,
    cy: 11.6666667,
    r: 11.6666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3333333,23.3333333 C23.3333333,16.8900113 18.1099887,11.6666667 11.6666667,11.6666667 C5.22334459,11.6666667 0,16.8900113 0,23.3333333 L23.3333333,23.3333333 Z",
    id: "Oval-4",
    transform: "translate(11.666667, 17.500000) scale(-1, -1) translate(-11.666667, -17.500000) "
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5-Copy-6",
    fill: "#CFDAE6",
    cx: 201.833333,
    cy: 87.5,
    r: 5.83333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,88.8126685 L155.070501,17.6038544",
    id: "Path-17",
    stroke: "#BACAD9",
    strokeWidth: 1.16666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,37.3333333 L127.466252,97.6449735",
    id: "Path-18",
    stroke: "#BACAD9",
    strokeWidth: 1.16666667
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-19",
    stroke: "#CFDAE6",
    strokeWidth: 1.16666667,
    points: "143.902597 120.302281 174.935455 231.571342 38.5 147.510847 126.366941 110.833333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.833333,99.7453842 L195.416667,89.25",
    id: "Path-20",
    stroke: "#E0B4B7",
    strokeWidth: 1.16666667,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.333333,82.1372105 L238.719406,36.1666667",
    id: "Path-24",
    stroke: "#BACAD9",
    strokeWidth: 1.16666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.723424,132.231988 L207.083333,90.4166667",
    id: "Path-25",
    stroke: "#CFDAE6",
    strokeWidth: 1.16666667
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#C1D1E0",
    cx: 156.916667,
    cy: 8.75,
    r: 8.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5-Copy-3",
    fill: "#C1D1E0",
    cx: 39.0833333,
    cy: 148.75,
    r: 5.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5-Copy-2",
    fillOpacity: 0.6,
    fill: "#D1DEED",
    cx: 8.75,
    cy: 33.25,
    r: 8.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5-Copy-4",
    fillOpacity: 0.6,
    fill: "#D1DEED",
    cx: 243.833333,
    cy: 30.3333333,
    r: 5.83333333
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5-Copy-5",
    fill: "#E0B4B7",
    cx: 175.583333,
    cy: 232.75,
    r: 5.25
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBg);
export default __webpack_public_path__ + "static/media/auth-bg.ebcb916068d431662f5b5c66e105a164.svg";
export { ForwardRef as ReactComponent };